import { Trans } from "@lingui/react";

const Disclaimer = () => {
  return (
    <div className="mt-16 md:mt-24 text-xs s-text-subtle">
      <p className="mb-0">
        <Trans
          id="itemPageLayout.disclamer"
          message="The advertisement may be incomplete. Complete sales information and details pursuant to the disclosure obligation can be obtained directly from the seller."
        />
      </p>
    </div>
  );
};

export default Disclaimer;
